import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/apis/client";

/**
 * 도메인 삭제 API 함수
 */
const deleteDomain = async (
  examConfigId: string,
  subject: string,
  domainId: string
): Promise<void> => {
  await apiClient.delete(
    `/exam_configs/${examConfigId}/subjects/${subject}/domains/${domainId}`
  );
};

/**
 * 도메인 삭제 훅
 */
export const useDeleteDomain = (examConfigId: string, subject: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (domainId: string) =>
      deleteDomain(examConfigId, subject, domainId),
    onSuccess: () => {
      // 도메인 목록 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: ["domains", examConfigId, subject],
      });
      // ExamConfig 쿼리 무효화 (도메인 정보 포함)
      queryClient.invalidateQueries({
        queryKey: ["examConfig", examConfigId],
      });
      queryClient.invalidateQueries({
        queryKey: ["examConfigs"],
      });
      // 카테고리 목록도 무효화 (도메인 삭제 시 카테고리 구조 변경 가능)
      queryClient.invalidateQueries({
        queryKey: ["categories"],
      });
    },
  });
};
